module.exports = __webpack_public_path__ + "img/pi.263052c5.svg";